
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13S3 23.168 3 16 8.832 3 16 3zm0 2c-2.647 0-5.073.918-6.969 2.469l15.344 15.656A10.936 10.936 0 0027 16c0-6.087-4.913-11-11-11zM7.625 8.875A10.936 10.936 0 005 16c0 6.087 4.913 11 11 11 2.647 0 5.073-.918 6.969-2.469z"}})])
          )
        }
      }
    